import { render } from "./PersonalDetailsComponent.vue?vue&type=template&id=fa93f8ae&scoped=true&ts=true"
import script from "./PersonalDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./PersonalDetailsComponent.vue?vue&type=script&lang=ts"

import "./PersonalDetailsComponent.vue?vue&type=style&index=0&id=fa93f8ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa93f8ae"]])

export default __exports__